import { Building2, FileText, ScanLine, Users } from 'lucide-react';

export const WORKBOOK_STEPS = [
    { key: 'business-info', icon: Building2 },
    { key: 'users', icon: Users },
    { key: 'scanners', icon: ScanLine },
    { key: 'policies', icon: FileText },
] as const;

export type WorkbookStepKey = (typeof WORKBOOK_STEPS)[number]['key'];

export const WIDE_WORKBOOK_STEPS = new Set<WorkbookStepKey>([
    'users',
    'scanners',
    'policies',
]);

